import { Divider, Group } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { AnchorSetting } from '@/components/AnchorSetting'
import { getBlockAndPageDesignLimit, PositionSetting } from '@/components/StyleSetting'
import AnimationSetting from '@/components/StyleSetting/AnimationSetting'
import { SizeSetting } from '@/components/StyleSetting/SizeSetting'
import { VisibilitySetting } from '@/components/VisibilitySetting'

import { BlockConfigureSegmentedControl } from '../Common/BlockConfigureSegmentedControl'
import { CursorSetting } from '../Common/CursorSetting'
import type { BlockSettingsSegmentedEnum } from '../constants'
import { BLOCK_SETTINGS_SEGMENTED_ENUM } from '../constants'
import { IframeInput } from './IframeInput'

interface IframeSettingProps {}

export const IframeSetting: React.FC<IframeSettingProps> = () => {
    const { control } = useFormContext()
    const styleProps = getBlockAndPageDesignLimit('iframe')
    const [currentTab, setCurrentTab] = useState<BlockSettingsSegmentedEnum>(BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN)

    return (
        <>
            <BlockConfigureSegmentedControl isInterAction value={currentTab} onChange={setCurrentTab} />

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN && (
                <>
                    <PositionSetting {...styleProps.position} />
                    <Divider />
                    <SizeSetting {...styleProps.size} />
                    <Divider />
                    <Controller name="cursor" render={({ field }) => <CursorSetting {...field} />} />
                </>
            )}

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.INTERACTION && <AnimationSetting />}

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.CONFIGURE && (
                <>
                    <Group label="网页链接">
                        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                            <Controller control={control} name="href" render={({ field }) => <IframeInput {...field} />} />
                        </ListItem4ByecodeUi>
                    </Group>
                    <Divider />
                    <AnchorSetting />
                    <Divider />
                    <VisibilitySetting />
                </>
            )}
        </>
    )
}
